import type { ReactNode } from "react";
import { useViewport } from "../../../../../hooks/useViewport";

/** Етикет над поле в „Депозити" — същият като „Сума дадена от клиента" в
 *  „Закрий" (`payment/GivenAmountField.tsx`): удебелен 14px (13px на таблет),
 *  вдясно по избор „по желание", полето на 10px под него, сива подсказка отдолу. */
export function DepositFormField({
  label,
  optionalLabel,
  hint,
  children,
}: {
  label: string;
  /** Текстът вдясно от етикета за незадължително поле („по желание"). */
  optionalLabel?: string;
  hint?: string;
  children: ReactNode;
}) {
  const { isTablet, isNarrow } = useViewport();
  const isCompact = isTablet && !isNarrow;
  return (
    <div className="flex min-w-0 flex-col">
      <div className="flex h-5 items-center justify-between gap-2">
        <span className={`truncate font-bold text-pos-ink ${isCompact ? "text-[13px]" : "text-[14px]"}`}>
          {label}
        </span>
        {optionalLabel && (
          <span
            className={`shrink-0 font-semibold text-pos-muted ${isCompact ? "text-[12px]" : "text-[12.5px]"}`}
          >
            {optionalLabel}
          </span>
        )}
      </div>
      <div className="mt-2.5">{children}</div>
      {hint && <span className="mt-1.5 text-[12.5px] font-medium leading-snug text-pos-soft2">{hint}</span>}
    </div>
  );
}
